import { Box, Paper, Stack, Typography } from '@mui/material';
import Section from './Section';
import { about } from '../../data/profile';

export default function About() {
    return (
        <Section id="perfil" eyebrow="Perfil personal" title="Sobre mí">
            <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '3fr 2fr' }, gap: { xs: 4, md: 6 } }}>
                <Stack spacing={2}>
                    {about.paragraphs.map((p) => (
                        <Typography key={p.slice(0, 20)} color="text.secondary" sx={{ fontSize: '1.05rem', lineHeight: 1.8 }}>
                            {p}
                        </Typography>
                    ))}
                </Stack>
                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2, alignContent: 'start' }}>
                    {about.facts.map((f) => (
                        <Paper key={f.label} variant="outlined" sx={{ p: 2.5 }}>
                            <Typography variant="caption" color="text.secondary">{f.label}</Typography>
                            <Typography sx={{ fontWeight: 700 }}>{f.value}</Typography>
                        </Paper>
                    ))}
                </Box>
            </Box>
        </Section>
    );
}
